import { TFeedbackOptions } from '../../_components/feedback-modal/_types';

export const getFeedbackReplies = (data: TFeedbackOptions): Array<string> =>
  Object.entries(data).reduce<Array<string>>((acc, [name, value]) => {
    if (value) {
      acc.push(name);
    }

    return acc;
  }, []);
